import type { IRect, IImageMeta } from './recognitionTypes';
import { rectSchema, imageMetaSchema } from './recognitionTypes';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

// detection results sent from ab-vision

export const DETECTION = 'VISION/DETECTION';

export interface IDetectionPayload {
  faceBox: IRect;
  imageMeta: IImageMeta;
  frameNumber: number;
}

export const detectionPayloadSchema = objectSchemaOf<IDetectionPayload>({
  faceBox: rectSchema.required(),
  imageMeta: imageMetaSchema.required(),
  frameNumber: Joi.number().required(),
});

export interface IDetectionAction {
  type: typeof DETECTION;
  payload: IDetectionPayload;
}

export const detectionActionSchema = objectSchemaOf<IDetectionAction>({
  type: Joi.string().required().valid(DETECTION),
  payload: detectionPayloadSchema.required(),
});

export const detection = actionCreator({
  type: DETECTION,
  schema: detectionActionSchema,
});
